export enum WearableModalType {
   SCAN = "scan",
   SCANNED = "scanned",
   MANUAL_ASSIGN = "manual-assign",
   MANUAL_SWAP = "manual-swap",
   OPTIONS = "options",
   ASSIGNED = "assigned",
   SWAPPED = "swapped",
   ASSIGN_NEW_INMATE = "assign-new-inmate",
   DISCONNECTED = "disconnected",
   UNKNOWN = "unknown",
   ALREADY_ASSIGNED = "already-assigned",
}

export interface Wearable {
   id: string
   macAddress: string
   batteryPercentage: number | null
}

export interface Step {
   label: string
   description: string
}
